export default {"src":"/_next/static/media/music_off.9b32410d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};